import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";

import { GET_ROLE_RATE } from "./graphql";

const RateBreakdown = ({ roleRateId, handleShiftUpdate }) => {
  const { data } = useQuery(GET_ROLE_RATE, {
    variables: {
      roleRateId,
    },
    skip: !roleRateId,
    fetchPolicy: "network-only",
  });

  const roleRate = data?.account?.roleRateById;

  useEffect(() => {
    if (roleRate) {
      handleShiftUpdate({
        isOnCallShiftsEnabledForRole: roleRate.isOnCallShiftsEnabled,
      });
    }
  }, [roleRate, handleShiftUpdate]);

  if (!roleRateId) {
    return null;
  }

  return <></>;
};

export default RateBreakdown;
